import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

/**
 * LR-388: book a PENDING partial recall (lend) / return (borrow) against a position.
 * Invalidates the whole positions cache (tradesKeys.all) so the trades list AND the MTM
 * page — which reads remaining_quantity from the same positions — both refetch and remark
 * the net remaining shape.
 */
export const usePartialRecall = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      quantity,
      settlement_date,
    }: {
      id: number;
      quantity: number;
      // LR-515: required at booking — a dateless recall can never be settled.
      settlement_date: string;
    }) => tradesService.partialRecall(id, { quantity, settlement_date }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
